export default "__VITE_ASSET__Dl0wzXz3__"